"use client";

import { Suspense } from "react";
import LoginForm from "../../components/authentification/LoginForm";
import Image from "next/image";

export default function LoginPage() {
    return (
        <div className="w-full lg:grid lg:min-h-screen lg:grid-cols-2">
            <div className="flex items-center justify-center py-12 bg-white">
                <div className="mx-auto grid w-[350px] gap-6">
                    <div className="grid gap-2 text-center">
                        <div className="flex justify-center mb-4">
                            <Image
                                src="/logo.png"
                                alt="Logo Croix-Rouge"
                                width={180}
                                height={180}
                                priority
                                className="h-auto w-auto object-contain"
                            />
                        </div>
                        <h1 className="text-3xl font-bold">Connexion</h1>
                        <p className="text-sm text-muted-foreground">
                            Entrez vos identifiants pour accéder à votre espace logistique.
                        </p>
                    </div>
                    <Suspense fallback={null}>
                        <LoginForm />
                    </Suspense>
                    <p className="px-8 text-center text-sm text-muted-foreground">
                        © {new Date().getFullYear()} Croix-Rouge Française
                    </p>
                </div>
            </div>
            <div className="hidden bg-muted lg:block relative">
                <Image
                    src="/bg_login_2.jpg"
                    alt="Equipe Croix-Rouge"
                    fill
                    className="object-cover"
                    priority
                />
                <div className="absolute inset-0 bg-black/40" />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-10 text-center z-10">
                    <div className="max-w-md space-y-4">
                        <h2 className="text-4xl font-bold">{process.env.NEXT_PUBLIC_APP_NAME || "CRF Logistique"}</h2>
                        <p className="text-lg opacity-90">
                            La solution de gestion logistique pour l'Urgence & le Secourisme.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}